import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { distinctUntilChanged, map, take } from 'rxjs/operators';

import { EasUser, OidcService } from '../core';
// import { toObservable } from '@angular/core/rxjs-interop';
import _ from 'lodash';

export interface AuthUserProfile {
  username: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  fullName?: string;
}

export interface CurrentUser {
  username: string;
  organisation: string;
  state: 'full' | 'noorg' | 'anonymous';
  original?: AuthUserProfile;
}

const anonymousUser: CurrentUser = {
  username: 'anonymous',
  organisation: 'unknown',
  state: 'anonymous',
};

@Injectable()
export class AuthService {
  // private jwtHelper; // TODO: declared but never read
  constructor(
    private oidc: OidcService,
  ) {
    // this.jwtHelper = new JwtHelperService(); // TODO: declared but never read
  }

  private _currentUser = new BehaviorSubject<CurrentUser>(anonymousUser);
  private currentUserDistinct = this._currentUser.asObservable().pipe(
    distinctUntilChanged((x, y) => {
      return x.username === y.username && x.organisation === y.organisation;
    })
  )

  public subscribeUserChange() {
    console.log('AuthService: Subscribing to oidc user change');
    this.currentUserDistinct.subscribe(user => {
      console.log(user);
      // this.cluster.setCurrentUser(user.username);
      // this.cluster.setClusterOrganisation(user.organisation);
    })

    // toObservable(this.oidc.currentUser).subscribe(_ => this.updateCurrentUser());
  }

  public currentUser() {
    return this.currentUserDistinct;
  }

  // public get token() {
  //   return this.oidc.getToken();
  // }

  // public set token(token: string) {
  //   this.authToken.token = token;
  //   this.updateCurrentUser();
  // }

  public get organisation() {
    return this.oidc.organisation;
  }

  public set organisation(organisation: string) {
    this.oidc.setOrganisation(organisation);
    this.updateCurrentUser();
  }

  public async loginAs(username: string) {
    await this.oidc.loginAs(username);
  }

  public async logoutAs() {
    await this.oidc.logoutAs();
  }

  public startLogin() {
    this.oidc.login();
  }

  public startLogout() {
    this.oidc.logout();
  }

  // public async handleCallback() {
  //   await this.oidc.completeAuthentication();
  // }

  // public async startLoginPopup() {
  //   await this.oidc.startAuthenticationPopup();
  // }

  // public async handleCallbackPopup() {
  //   await this.oidc.completeAuthenticationPopup();
  // }

  // public async handleCallbackSilent() {
  //   this.oidc.completeAuthenticationSilent();
  // }

  public logout() {
    return new Observable((observer) => {
      observer.next(this.isLoggedIn);
    });
  }

  get isLoggedIn(): boolean {
    const user = this.oidc.currentUser();
    if (!user) {
      return false;
    }
    if (user.username === 'anonymous') {
      return false;
    }
    return !user.user?.expired;
  }

  get current(): CurrentUser {
    if (!this.isLoggedIn) {
      return anonymousUser;
    }
    return this.easUserToCurrentUser(this.oidc.currentUser());
  }

  public updateCurrentUser() {
    const current = this.current;
    console.log(`AuthService.updateCurrentUser: Updating to ${JSON.stringify(current)}`);
    this._currentUser.next(current);
  }

  public isUserCurrent(username: string): Observable<boolean> {
    return this.currentUser().pipe(
      take(1),
      map(currentUser => currentUser.username === username),
    );
  }

  private easUserToCurrentUser(user: EasUser): CurrentUser {
    const authUser: CurrentUser = {
      username: user.username,
      organisation: this.oidc.organisation,
      state: this.oidc.organisation ? 'full' : 'noorg',
    };
    if (user.masqueradeBy) {
        authUser.original = user.originalProfile;
    }
    return authUser;
  }
}
